<template>
  <el-dialog
    ref="endDialog"
    title="End Customer Search"
    :visible.sync="visible"
    width="800px"
    append-to-body
    :close-on-click-modal="false"
    custom-class="opp-endcustomer-dialog"
  >
    <!-- 信息行（参考 cqm2 Customer 的 .small-text）：左侧动态结果数 + 从 General Information 带入的 Ordering Customer Name，右侧刷新图标 -->
    <div class="info-bar" ref="infoBar">
      <div class="info-text">
        <span>{{ list.length }} result{{ list.length>1?'s':'' }}</span>
        <template v-if="orderingCustomerName">
          <span class="dot">•</span>
          <span>{{ orderingCustomerName }}</span>
        </template>
      </div>
      <!-- 刷新图标：复用全局橙色图标按钮类 .btn-with-icon-with-bg + .icon-refresh(public2.less 29/46 行)，字形 e611(ico_refresh) -->
      <div class="btn-with-icon-with-bg refresh-btn" @click="getList">
        <span class="iconfont icon-refresh">&#xe611;</span>
      </div>
    </div>
    <!-- 无搜索、无分页，直接展示后端返回的 End Customer 列表；单击选中、双击直接确认 -->
    <div class="table-wrap" v-loading="loading">
      <el-table
        ref="table"
        class="cqm-table"
        highlight-current-row
        size="mini"
        :height="tableHeight"
        style="width: 100%"
        :data="list"
        @row-click="handleRowClick"
        @cell-dblclick="handleDblClick"
      >
        <el-table-column
          align="center"
          width="70"
          label="">
          <template slot-scope="scope">
            <span class="iconfont icon-check icon-active" v-show="selected && selected.endCustomerCode==scope.row.endCustomerCode">&#xe730;</span>
            <span class="iconfont icon-check" v-show="!selected || selected.endCustomerCode!=scope.row.endCustomerCode">&#xe72f;</span>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          type="index"
          label=""
          width="50">
        </el-table-column>
        <el-table-column
          prop="endCustomerName"
          label="End Customer Name">
        </el-table-column>
        <el-table-column
          width="200"
          prop="endCustomerCode"
          label="End Customer No.">
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <div class="dialog-cancel" @click="close">Cancel</div>
      <div class="dialog-select" @click="handleSelect">Select</div>
    </div>
  </el-dialog>
</template>

<script>
import {api_end_customer_list} from '@/api/api'
import {getAction} from '@/api/tool'

export default {
  name:'EndCustomer',
  data(){
    return {
      visible:false,
      loading:false,
      list:[],
      tableHeight:0, //表格固定高(px)，由 handleResize 量弹窗内容区得出（代替 height="100%"，参考 cqm2 Customer）
      selected:null, //当前选中的行
      pendingCode:'', //外部已选的 endCustomerCode，进入弹窗时用于自动勾选
      orderingCustomerName:'' //从 General Information 带入的 Ordering Customer Name，显示在信息行
    }
  },
  methods:{
    /* 打开弹窗：重置选中态并拉取列表；currentCode 为外部已选值(自动勾选)，orderingCustomerName 显示在信息行 */
    open(currentCode, orderingCustomerName){
      this.visible=true
      this.selected=null
      this.pendingCode = currentCode || ''
      this.orderingCustomerName = orderingCustomerName || ''
      this.getList()
      this.$nextTick(()=>{
        if(this.$refs.table){
          this.$refs.table.setCurrentRow(null) //先清掉上次遗留的高亮，再由 autoSelect 重新定位
        }
        // 弹窗显示后再量高（隐藏时 offsetHeight 为 0），并监听窗口变化，参考 cqm2 Customer.handleOpen
        this.handleResize()
        window.addEventListener('resize', this.handleResize)
      })
    },
    close(){
      this.visible=false
      window.removeEventListener('resize', this.handleResize)
    },
    /* 计算表格固定高：直接量弹窗内容区(.el-dialog__body，flex:1 且 padding:0)的可用高，用数值高替代
       height="100%"——百分比高在 append-to-body 弹窗里量不准，会导致空数据时也常驻滚动条 */
    handleResize(){
      this.$nextTick(()=>{
        let dialogEl = this.$refs.endDialog && this.$refs.endDialog.$el
        if(!dialogEl) return
        let bodyEl = dialogEl.querySelector('.el-dialog__body')
        let bodyH = bodyEl ? bodyEl.clientHeight : 0
        let infoH = this.$refs.infoBar ? this.$refs.infoBar.offsetHeight : 0
        let h = bodyH - infoH //扣除信息行高度，剩余给表格
        this.tableHeight = h > 100 ? h : 100
        if(this.$refs.table){
          this.$refs.table.doLayout()
        }
      })
    },
    /* 拉取 End Customer 列表（GET，无搜索无分页）；后端可能直接返回数组或 {records:[]}，做兼容 */
    getList(){
      this.loading=true
      getAction(api_end_customer_list).then(res=>{
        this.loading=false
        if(Array.isArray(res)){
          this.list=res
        }else{
          this.list=(res && (res.records || res.list)) || []
        }
        this.autoSelect() //列表到位后，按外部已选值自动勾选
      }).catch(()=>{
        this.loading=false
      })
    },
    /* 单击行选中（highlight-current-row 负责高亮，这里记录选中项供 Select 按钮使用） */
    handleRowClick(row){
      this.selected=row
    },
    /* 进入弹窗时若外部已选过(有 endCustomerCode)，在列表里找到对应行自动勾选并高亮 */
    autoSelect(){
      if(!this.pendingCode){
        return
      }
      let matched = this.list.find(item=>item.endCustomerCode==this.pendingCode)
      if(matched){
        this.selected = matched
        this.$nextTick(()=>{
          if(this.$refs.table){
            this.$refs.table.setCurrentRow(matched)
          }
        })
      }
    },
    /* 双击行直接确认返回 */
    handleDblClick(row){
      this.emitSelect(row)
    },
    /* 点击 Select 按钮确认 */
    handleSelect(){
      if(!this.selected){
        this.$message.warning('Please select an end customer first.')
        return
      }
      this.emitSelect(this.selected)
    },
    /* 把选中行抛给父组件并关闭弹窗 */
    emitSelect(row){
      this.$emit('select',{ ...row })
      this.close()
    }
  },
  beforeDestroy(){
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style lang="less">
@import url('/public/css/public.less');
/*
  本弹窗用 append-to-body：Element 内部节点(.el-dialog__header/__body/__footer)被搬到 <body> 下、
  不带组件 data-v，scoped(含 ::v-deep)命中不到，故整块走非 scoped 全局样式；
  组件自身模板元素(.info-bar/.table-wrap/.dialog-footer)也都在该弹窗内，一并嵌到
  custom-class="opp-endcustomer-dialog" 命名空间下，既保证生效又不污染全站。
  外观照抄 cqm2：body padding:0(表格撑满无留白)、标题左对齐、footer 灰底；
  居中用 absolute + top/left:50% + translate(-50%,-50%) + margin:0!important(盖 Element 内联 margin-top)。
*/
.opp-endcustomer-dialog{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  height: 80vh;
  max-height: 80vh;
  box-sizing: border-box;
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0,0,0,.3);
  .el-dialog__header{
    flex-shrink: 0;
    padding: 16px;
    text-align: left; /* 标题左对齐 */
    box-sizing: border-box;
    .el-dialog__title{
      line-height: 24px;
      font-size: 17px;
      color: @mainFontColor;
      font-weight: 600;
    }
    .el-dialog__headerbtn{
      top: 16px;
      right: 16px;
      .el-dialog__close{
        color: @inpNumColor;
        font-weight: 600;
      }
      &:hover .el-dialog__close{ color: @tableNoAndBtnColor; }
    }
  }
  .el-dialog__body{
    flex: 1;
    min-height: 0;
    padding: 0; /* 去掉留白，表格撑满整个内容区 */
    overflow: hidden;
    font-size: 13px;
    color: @mainFontColor;
  }
  .el-dialog__footer{
    flex-shrink: 0;
    padding: 16px;
    text-align: right;
    box-sizing: border-box;
    background-color: @darkBgcColor;
  }
  /* ===== 以下为组件自身模板元素(原 scoped 块)，同处命名空间内 ===== */
  /* 信息行：左侧动态结果数 + Ordering Customer Name，右侧刷新图标。
     底色改用白(不用灰 @darkBgcColor)：信息行若与下方表头同为 #f3f3f3，二者之间那根 #c9c9c9 线会被“灰-灰”夹击而显得比别处浅；
     白底后表格顶边框 #c9c9c9 变成“白-灰”相邻，与行分隔线同等对比度，视觉一致 */
  .info-bar{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    background-color: @darkBgcColor;
    box-sizing: border-box;
    border-top: 1px solid @darkBorderColor;
    .info-text{
      font-size: 12px;
      color: @mainFontColor;
      .dot{
        margin: 0 6px;
      }
    }
    .refresh-btn{
      margin-left: 0; /* 抵消 .btn-with-icon-with-bg 默认 margin-left:6px，贴齐最右 */
      flex-shrink: 0;
    }
  }
  .table-wrap{
    /* 表格外观走全局公共类 .cqm-table(public/css/public2.less)，此处只留本页专有样式 */
    /* 本弹窗特有：表格去掉圆角(全局 .cqm-table 默认 border-radius:4px)；只在本命名空间内覆盖，不影响其它文件的表格 */
    .el-table.cqm-table{
      border-radius: 0;
    }
    /* 选中行淡橙底，便于辨识当前选择 */
    .el-table__body tr.current-row > td.el-table__cell{
      background-color: fade(@mainColor, 10%);
    }
    /* select 列勾选图标(沿用 ecommerce CustomerList 的 icon-check：未选 e72f 灰、已选 e730 橙) */
    .icon-check{
      font-size: 17px;
      color: #ccc;
      &:hover{
        cursor: pointer;
      }
    }
    .icon-active{
      color: @mainColor;
    }
  }
  /* 底部 Cancel/Select 用全局公共类 .dialog-cancel/.dialog-select(public2.less)，此处只留右对齐 */
  .dialog-footer{
    text-align: right;
  }
}
</style>
